import { render, staticRenderFns } from "./menu-sales-claim.vue?vue&type=template&id=d09bc9d4&"
import script from "./menu-sales-claim.vue?vue&type=script&lang=js&"
export * from "./menu-sales-claim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports